module.exports = __webpack_public_path__ + "img/4.b4e8128c.svg";